// extracted by css-extract-rspack-plugin
export default {"content":"content--lC6DGrYGn2EvUq7G"};